module.exports = __webpack_public_path__ + "img/lb2.b0cfc6eb.png";